import { useStaticQuery, graphql } from "gatsby";

import { Query } from "@graphql-types";

export default function getAllBrands() {
  const { allSanityBrand }: Query = useStaticQuery(graphql`
    {
      allSanityBrand{
        nodes{
          title
        }
      }
    }
  `);

  return { allSanityBrand };
}
